export const Panel = ({ title, children, testId, right }) => (
  <section className="hud-panel settings-panel p-4 sm:p-5 mb-4" data-testid={testId}>
    {title && <div className="settings-panel-heading"><h2 className="font-hud text-sm tracking-[0.2em] text-cyan-300">{title}</h2>{right}</div>}
    {children}
  </section>
);

export const Field = ({ label, children }) => (
  <label className="block mb-3"><span className="hud-label">{label}</span><div className="mt-1">{children}</div></label>
);

export const inputCls = "interface-input w-full border border-cyan-500/30 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none focus:border-cyan-400 transition-colors";

export const Action = ({ children, onClick, testId, variant = "primary", disabled, type = "button" }) => (
  <button type={type} data-testid={testId} onClick={onClick} disabled={disabled}
    className={`interface-action px-3 py-2 text-xs font-ui font-semibold uppercase tracking-[0.15em] transition-colors disabled:opacity-50 ${
      variant === "danger" ? "border border-red-500/60 text-red-300 hover:bg-red-500/10"
      : variant === "ghost" ? "border border-slate-700 text-slate-300 hover:bg-slate-800"
      : "bg-cyan-400 text-slate-950 hover:bg-cyan-300"}`}>{children}</button>
);

export const Note = ({ children }) => <p className="text-[11px] text-slate-500 leading-relaxed">{children}</p>;
